import * as dayjs from 'dayjs';
import { DateValue } from '@core/locale/types/date-value';

export const dateFormat = (date: DateValue, format: string): string =>
  dayjs(date).format(format);
